import { render, staticRenderFns } from "./MainNavbarGeneralModal.vue?vue&type=template&id=2ab3f018"
import script from "./MainNavbarGeneralModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavbarGeneralModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports